package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ActionAmount(
    @SerialName("less")
    val less: Double?,
    @SerialName("more")
    val more: Double?,
    @SerialName("__typename")
    val typename: String?
)